/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Jotkin API
 * LINE-driven calorie logging and dashboard API. This tool estimates calories for general wellness; it is not medical advice.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GoalDto,
  UpsertGoalDto
} from '../model';

import { apiFetch } from '../../lib/api-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetGoalUrl = () => {




  return `/api/goal`
}

/**
 * Returns null when the user has not set a goal yet.
 * @summary Get the current goal
 */
export const getGoal = async ( options?: Parameters<typeof apiFetch>[1]): Promise<GoalDto> => {

  return apiFetch<GoalDto>(getGetGoalUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGoalQueryKey = () => {
    return [
    `/api/goal`
    ] as const;
    }


export const getGetGoalQueryOptions = <TData = Awaited<ReturnType<typeof getGoal>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoalQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoal>>> = ({ signal }) => getGoal({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getGoal>>>
export type GetGoalQueryError = void


export function useGetGoal<TData = Awaited<ReturnType<typeof getGoal>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoal>>,
          TError,
          Awaited<ReturnType<typeof getGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoal<TData = Awaited<ReturnType<typeof getGoal>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoal>>,
          TError,
          Awaited<ReturnType<typeof getGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoal<TData = Awaited<ReturnType<typeof getGoal>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current goal
 */

export function useGetGoal<TData = Awaited<ReturnType<typeof getGoal>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoal>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGoalQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpsertGoalUrl = () => {




  return `/api/goal`
}

/**
 * Recomputes BMR, TDEE and the daily budget server-side. The mandatory safety clamps (max 0.75 kg/week, 1500/1200 kcal floor) are always applied; when they bind, the response carries a `warning` with the earliest safe date.
 * @summary Create or update the goal
 */
export const upsertGoal = async (upsertGoalDto: UpsertGoalDto, options?: Parameters<typeof apiFetch>[1]): Promise<GoalDto> => {

  return apiFetch<GoalDto>(getUpsertGoalUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertGoalDto)
  }
);}





export const getUpsertGoalMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertGoal>>, TError,{data: UpsertGoalDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertGoal>>, TError,{data: UpsertGoalDto}, TContext> => {

const mutationKey = ['upsertGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertGoal>>, {data: UpsertGoalDto}> = (props) => {
          const {data} = props ?? {};

          return  upsertGoal(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertGoalMutationResult = NonNullable<Awaited<ReturnType<typeof upsertGoal>>>
    export type UpsertGoalMutationBody = UpsertGoalDto
    export type UpsertGoalMutationError = void

    /**
 * @summary Create or update the goal
 */
export const useUpsertGoal = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertGoal>>, TError,{data: UpsertGoalDto}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertGoal>>,
        TError,
        {data: UpsertGoalDto},
        TContext
      > => {
      return useMutation(getUpsertGoalMutationOptions(options), queryClient);
    }
